import React from 'react';
import styled from 'styled-components';
export default function AccountFormShell({ children, title }) {
    return (React.createElement(AccountFormWrapper, null,
        React.createElement(FormContainer, null,
            React.createElement("a", { href: "/" },
                React.createElement(Logo, { src: "/images/brandlogo-white.png" })),
            React.createElement(HeaderText, null, title),
            children)));
}
const AccountFormWrapper = styled.div `
  min-height: calc(100vh - 5px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 18px;
  width: 100%;
  box-sizing: border-box;
`;
const FormContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 30px 0px;
`;
const Logo = styled.img `
  width: 280px;
  /* width: 90px; */
`;
const HeaderText = styled.div `
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: white;
  opacity: 0.8;
  letter-spacing: 0.05em;
  margin-top: 18px;
  margin-bottom: 38px;
`;
